exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.banner-changer[data-v-7cb2e3ae]::after {\n  background: #000;\n  opacity: 0.6;\n  content: '';\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  border-radius: 0.25rem;\n}\n.vc-twitter[data-v-7cb2e3ae] {\n  box-shadow: none !important;\n  border: 1px solid rgb(212, 212, 212);\n}\n", ""]);

// exports
